<template>
  <div>
    <loader
      v-if="loader"
      object="#2E7D32"
      color1="#398abe"
      color2="#92c2bf"
      size="5"
      speed="1.5"
      objectbg="#999793"
      opacity="5"
      disableScrolling="false"
      name="circular"
    ></loader>
  </div>
</template>
<script>
export default {
  props: {
    loader: {
      type: Boolean,
      default: true,
    },
  },
  // bg="#9199a1"
};
</script>
